var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isPopupVisible),expression:"isPopupVisible"}],ref:"notificationPopup",class:_vm.clsx('notification-popup', { 'notification-popup--visible': _vm.isPopupVisible }),attrs:{"role":"dialog","aria-hidden":!_vm.isPopupVisible},on:{"click":function () { return _vm.closePopup(this$1.getPopupId); }}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }